module.exports = __webpack_public_path__ + "static/media/marcas (8).11beaaa2.jpg";